import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common/common.service';
import { DataPocketService } from 'src/app/services/data-pocket/data-pocket.service';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { AppRoute } from 'src/app/shared/constants/app-route.constant';
import { PHOTOBOOTH_MODAL_OPTIONS } from 'src/app/shared/constants/modal-options.constant';
import { AppTheme, GlobalConfigKey, StorageKey } from 'src/app/shared/constants/global-config.constant';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent {

  constructor(
    private router: Router,
    private ngbModal: NgbModal,
    public commonService: CommonService,
    private dataPocketService: DataPocketService,
    private themeService: ThemeService,

  ) { }

  theme = this.themeService.getTheme();

  modalRef: NgbModalRef;
  @ViewChild('termTab') content;

  // static: true — #termsBody sits at the top level of the template (no structural directive
  // above it), so it resolves before the first change detection pass. That matters because a
  // themed view reads host.termsBody during its own first render.
  @ViewChild('termsBody', { static: true }) termsBody: TemplateRef<any>;

  async ngAfterViewInit() {

    try {
      this.checkSkipTerms();
    }
    catch (err) {
      console.error(err);
    }
    finally {

    }

  }

  openModal() {
    this.modalRef = this.ngbModal.open(this.content, { ...PHOTOBOOTH_MODAL_OPTIONS, scrollable: true, windowClass: 'width-80' });
  }

  onDecline() {
    // Themed views render the terms inline instead of in a modal, so there is no modalRef.
    if (this.modalRef) {
      this.modalRef.close();
    }
    this.router.navigate([AppRoute.HOME]);
  }

  async onAccept() {

    this.commonService.isLoading = true;
    try {
      if(this.modalRef) {
        this.modalRef.close();
      }
      await this.checkFreeWhiteList();
      // this.router.navigate([AppRoute.PAYMENT_OR_PROMO]);
    }
    catch (err) {
      console.log(err);
    }
    finally {
      this.commonService.isLoading = false;
    }

  }

  async checkFreeWhiteList() {
    const configResult = this.commonService.getConfigFreeWhitelistBranch();
    if (configResult) {
      const useFaceDetection = await this.checkUseFaceDetection()
      if (configResult.length > 0) {
        if (configResult.includes(localStorage.getItem(StorageKey.BRANCH_CODE))) {
          localStorage.setItem(StorageKey.IS_FREE_WHITELIST, 'true');
          if (useFaceDetection) {
            this.router.navigate([AppRoute.PAYMENT_OR_PROMO]);
          }
          else {
            this.router.navigate([AppRoute.PAYMENT_SUCCESS]);
          }
        }
        else {
          localStorage.setItem(StorageKey.IS_FREE_WHITELIST, 'false');
          this.router.navigate([AppRoute.PAYMENT_OR_PROMO]);
        }
      }
      console.log(configResult);
    }
  }

    async checkUseFaceDetection() {
      const configResult = this.commonService.getConfigUseFaceDetection();
      if (configResult) {
        if (configResult.length > 0) {
          if (configResult.includes(localStorage.getItem(StorageKey.BRANCH_CODE))) {
            localStorage.setItem(StorageKey.USE_FACE_DETECTION, 'true');
            return true;
          }
          else {
            localStorage.setItem(StorageKey.USE_FACE_DETECTION, 'false');
            return false;
          }
        }
        else {
          localStorage.setItem(StorageKey.USE_FACE_DETECTION, 'false');
          return false;
        }
      }
      console.log(configResult);
    }

  async checkSkipTerms() {
    const configResult = this.commonService.getConfigSculptureBranchSkipTerms();
    if (configResult) {
      if (configResult.length > 0) {
        if (configResult.includes(localStorage.getItem(StorageKey.BRANCH_CODE))) {
          console.log('auto accept');
          await this.onAccept();
        }
        else if (this.theme === AppTheme.DEFAULT) {
          this.openModal();
        }
        // Themed views render the terms as a full page — nothing to open.
      }
      console.log(configResult);
    }
  }

}
